import { render, staticRenderFns } from "./BenvenutoImg.vue?vue&type=template&id=5c85dd1e&scoped=true"
import script from "./BenvenutoImg.vue?vue&type=script&lang=js"
export * from "./BenvenutoImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2cae27f83758b46b73a9745eca16177c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c85dd1e",
  null
  
)

export default component.exports